/**
 * 代理配置管理
 * 用于控制接口是否通过代理访问
 */

// ========== 代理开关配置 ==========
// 从环境变量获取代理设置，默认为 true（使用代理）
const USE_PROXY = false;

// 代理服务器配置（仅在USE_PROXY为true时生效）
// 自动检测环境：开发环境使用localhost:8080，生产环境使用当前页面的host
function getProxyConfig() {
  // 如果是在浏览器环境中且不是localhost，则使用当前页面的host
  if (typeof window !== 'undefined' && window.location) {
    const isLocalhost = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1'
    if (!isLocalhost) {
      // 生产环境：使用当前页面的host和port
      return {
        host: window.location.hostname,
        port: window.location.port || '80',
        protocol: window.location.protocol.replace(':', ''),
        pathPrefix: '/api'
      }
    }
  }
  // 开发环境或Node.js环境：使用localhost:8080的Vue开发服务器代理
  return {
    host: 'localhost',
    port: '8080',
    protocol: 'http',
    pathPrefix: '/api'  // 开发环境下使用/api前缀进行代理
  }
}

const PROXY_CONFIG = getProxyConfig()

// 原始接口地址
const DIRECT_URLS = {
  ipVerify: 'https://hongchen8.asia:19107/config/verifyIpPermanent ',
  clubApi: 'https://hongchen8.asia:19107/config/key/%E5%8D%95%E4%BF%B1%E4%B9%90%E9%83%A8%E9%85%8D%E7%BD%AE',
  cardStatus: 'https://hongchen8.asia:19107/config/ip/status',
  cardActivate: 'https://hongchen8.asia:19107/config/ip/activate',
  announcement: 'https://hongchen8.asia:19107/config/key/INFOMATION',
  checkStatus: 'https://hongchen8.asia:19107/config/ip/check-status'
}
// ===============================

class ProxyConfig {
  constructor() {
    this.useProxy = USE_PROXY
    this.proxySettings = PROXY_CONFIG
    this.directSettings = DIRECT_URLS
  }

  /**
   * 获取是否使用代理
   * @returns {boolean}
   */
  isProxyEnabled() {
    return this.useProxy
  }

  /**
   * 获取IP验证接口URL
   * @returns {string}
   */
  getIpVerifyUrl() {
    if (this.useProxy) {
      const { protocol, host, port, pathPrefix } = this.proxySettings
      return `${protocol}://${host}:${port}${pathPrefix}/config/verifyIpPermanent `
    }
    return this.directSettings.ipVerify
  }

  /**
   * 获取俱乐部接口URL
   * @returns {string}
   */
  getClubApiUrl() {
    if (this.useProxy) {
      const { protocol, host, port, pathPrefix } = this.proxySettings
      return `${protocol}://${host}:${port}${pathPrefix}/config/key/%E5%8D%95%E4%BF%B1%E4%B9%90%E9%83%A8%E9%85%8D%E7%BD%AE`
    }
    return this.directSettings.clubApi
  }

  /**
   * 获取卡密状态查询接口URL
   * @returns {string}
   */
  getCardStatusUrl() {
    if (this.useProxy) {
      const { protocol, host, port, pathPrefix } = this.proxySettings
      return `${protocol}://${host}:${port}${pathPrefix}/config/ip/status`
    }
    return this.directSettings.cardStatus
  }

  /**
   * 获取卡密激活接口URL
   * @returns {string}
   */
  getCardActivateUrl() {
    if (this.useProxy) {
      const { protocol, host, port, pathPrefix } = this.proxySettings
      return `${protocol}://${host}:${port}${pathPrefix}/config/ip/activate`
    }
    return this.directSettings.cardActivate
  }

  /**
   * 获取公告接口URL
   * @returns {string}
   */
  getAnnouncementUrl() {
    if (this.useProxy) {
      const { protocol, host, port, pathPrefix } = this.proxySettings
      return `${protocol}://${host}:${port}${pathPrefix}/config/key/INFOMATION`
    }
    return this.directSettings.announcement
  }

  /**
   * 获取状态检查接口URL
   * @returns {string}
   */
  getCheckStatusUrl() {
    if (this.useProxy) {
      const { protocol, host, port, pathPrefix } = this.proxySettings
      return `${protocol}://${host}:${port}${pathPrefix}/config/ip/check-status`
    }
    return this.directSettings.checkStatus
  }
}

// 创建单例实例
const proxyConfig = new ProxyConfig()

export default proxyConfig



// WEBPACK FOOTER //
// ./src/config/proxyConfig.js